import React from 'react';
import { Card, Row, Stack, Text } from 'library/ui';
import { IProviderReviewOption } from 'models';
import ReviewOptionSelect from 'parent-portal/home/providerReivewModal/ReviewOptionsSelect';

export default function ProgramImpactSection({
    options,
    value,
    onChange,
}: {
    options: IProviderReviewOption[];
    value: number[];
    onChange: (value: number[]) => void;
}) {
    if (options.length === 0) return null;

    return (
        <Card tone="muted" padding="md">
            <Stack gap="sm">
                <Row justify="between" align="center" gap="sm">
                    <Text size="sm" weight="semibold" tone="accent" uppercase>
                        Separate from your review
                    </Text>
                    <Text size="sm" tone="secondary">
                        Optional
                    </Text>
                </Row>
                <Text weight="bold">How did having this substitute affect your program?</Text>
                <ReviewOptionSelect options={options} value={value} onChange={onChange} isScoreNeutral />
            </Stack>
        </Card>
    );
}
